

export class PushNotifFilterModel {
    public searchText: string;
    public onlyDelivered: boolean;
    public onlySended: boolean;
}


// WEBPACK FOOTER //
// ./src/app/core/models/pushNotifFilter.Model.ts